import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Loading } from './components/Loading';
import ModalManager from './components/Modal/ModalManager';
import {
  LeftSection,
  MainContainer,
  MainSection,
  RightSection
} from './components/containers';
import { GOOGLE_SHEET_API_OUTCOME } from './constants';
import { ModalProvider } from './context/ModalContext';
import { PdfProvider } from './context/PdfContext';
import GlobalStyle from './globalStyles';
import { saveSheet } from './redux/features/spreadsheet/spreadsheetSlice';
import { useAppDispatch } from './redux/hooks';
import { fetchSheets } from './services/api';

function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingError, setLoadingError] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const storeSheets = async () => {
    try {
      await fetchSheets().then((sheets) => {
        for (const spreadsheet of Object.keys(sheets)) {
          dispatch(saveSheet({ spreadsheet, value: sheets[spreadsheet] }));
        }
      });
      return GOOGLE_SHEET_API_OUTCOME.SUCCESS;
    } catch (e) {
      return GOOGLE_SHEET_API_OUTCOME.ERROR;
    }
  };

  useEffect(() => {
    storeSheets().then((outcome) => {
      setLoading(outcome === GOOGLE_SHEET_API_OUTCOME.ERROR);
      setLoadingError(outcome === GOOGLE_SHEET_API_OUTCOME.ERROR);
    });
  }, []);

  return (
    <PdfProvider>
      <ModalProvider>
        <ModalManager />
        <BrowserRouter>
          <GlobalStyle />
          {loading ? (
            <Loading loadingError={loadingError} />
          ) : (
            <MainContainer>
              <LeftSection />
              <MainSection />
              <RightSection />
            </MainContainer>
          )}
        </BrowserRouter>
      </ModalProvider>
    </PdfProvider>
  );
}

export default App;
